import React from 'react';

import { ItemGroupProps } from 'types/ItemGroupProps';
import * as S from './styled';

interface CarouselStoriesProps {
  data: ItemGroupProps;
  phoneWidth: number;
}

export default function CarouselStories({
  data,
  phoneWidth,
}: CarouselStoriesProps) {
  function shrinkText(text: string, qtdCute = 10) {
    if (typeof text === 'string') {
      const textLength = text.length;
      if (textLength <= qtdCute) {
        return text;
      }
      return `${text.slice(0, qtdCute)}...`;
    }
    return text;
  }

  return (
    <S.container>
      {data.items.length === 0 ? (
        <S.noItens>
          <p>Não há itenss</p>
        </S.noItens>
      ) : (
        <S.containerItens>
          {data.items.map(item => (
            <S.item>
              <img src={item?.file?.url || ''} alt="imagem carrossel" />
              <p>{shrinkText(item.name)}</p>
            </S.item>
          ))}
        </S.containerItens>
      )}
    </S.container>
  );
}
